import {
  jb_service_navigation_item_css_default
} from "./chunk.FBZJJQLD.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  Linkable
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  attachInterestEvents
} from "./chunk.AHMM4X2O.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  o,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-service-navigation-item/jb-service-navigation-item.ts
var JbServiceNavigationItem = class extends Initiable(Linkable(i)) {
  constructor() {
    super(...arguments);
    this._hovered = false;
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;
    attachInterestEvents(this._activeElement);
  }
  getIconComponent(iconName) {
    switch (iconName) {
      case "contact-icon":
        return b`<jb-icon iconName="call"></jb-icon><slot></slot>`;
      case "e-service-icon":
        return b`<jb-e-service-icon
            iconName="animated:eservice"
            class="${e2({ hover: this._hovered })}"
          ></jb-e-service-icon
          ><slot></slot>`;
      case "legal-icon":
        return b`<jb-icon iconName="contract"></jb-icon><slot></slot>`;
      default:
        return b`<slot></slot>`;
    }
  }
  render() {
    return b`
      <span
        class=${e2({
      "mobile-menu": this.parentElement?.slot === "",
      "first-element": this.previousElementSibling === null,
      "service-navigation-item": true,
      "service-navigation-item--animate-left": true
    })}
      >
        <a
          data-linkable
          class="service-navigation-item__text"
          aria-label="${this.ariaLabels?.label ?? A}"
          @interest=${() => {
      this._hovered = true;
    }}
          @loseinterest=${() => {
      this._hovered = false;
    }}
        >
          ${this.getIconComponent(this.icon)}
        </a>
      </span>
    `;
  }
};
JbServiceNavigationItem.styles = [reset_css_default, jb_service_navigation_item_css_default];
JbServiceNavigationItem.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Object })
], JbServiceNavigationItem.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbServiceNavigationItem.prototype, "icon", 2);
__decorateClass([
  n()
], JbServiceNavigationItem.prototype, "trackingLabel", 2);
__decorateClass([
  e("a")
], JbServiceNavigationItem.prototype, "_activeElement", 2);
__decorateClass([
  r()
], JbServiceNavigationItem.prototype, "_hovered", 2);
__decorateClass([
  o()
], JbServiceNavigationItem.prototype, "_slotContent", 2);
JbServiceNavigationItem = __decorateClass([
  customElement("jb-service-navigation-item")
], JbServiceNavigationItem);

export {
  JbServiceNavigationItem
};
